import { Component, OnInit, ViewChild } from '@angular/core';
import { Carousel } from 'primeng/carousel';

import { Testimonial } from './home.models';

@Component({
  styleUrls: ['./home.component.css'],
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  @ViewChild('carouselTest') carouselComponent: Carousel;
  testimonals: Testimonial[] = [];

  /** @ignore */
  ngOnInit(): void {
    const one = {
      author: 'Larry K.',
      experience: '',
      testimonial: `C.R. England has been a great place to work because it is stable and
         they focus deeply on safety and I think their training is the top in the industry.`,
      title: 'Experienced Driver Dedicated',
    } as Testimonial;

    const two = {
      author: 'Rodney W.',
      experience: '',
      testimonial: `C.R. England has always taken care of me, if I have needed to get home for something
        they just make sure they get it taken care of. I can get out and see the world,
        I like that I am not in the same building everyday.`,
      title: 'Experienced OTR Driver & Million Miler',
    } as Testimonial;

    const three = {
      author: 'Rodney W.',
      experience: '',
      testimonial: `My instructors were very informative, patient and knowledgeable,
        because of this I passed my test with ease.`,
      title: 'Student',
    } as Testimonial;

    const four = {
      author: 'Michaela',
      experience: 'Less than 6 Months',
      testimonial: `C.R. England is willing to work with you. They help you get your CDL at no
        cost to you per agreement being met. All of the staff are very friendly and
        willing to take the time out to help make sure you succeed. I would recommend this
        place to everyone.`,
      title: 'Driver',
    } as Testimonial;

    this.testimonals.push(one);
    this.testimonals.push(two);
    this.testimonals.push(three);
    this.testimonals.push(four);
  }

  onSwipeLeft(): void {
    const currentPage = this.carouselComponent.page;
    const totalPages = this.testimonals.length;
    if (currentPage === totalPages - 1) {
      this.carouselComponent.page = 0;
      return;
    }
    if (currentPage < totalPages - 1) {
      this.carouselComponent.page = currentPage + 1;
      return;
    }
  }

  onSwipeRight(): void {
    const currentPage = this.carouselComponent.page;
    const totalPages = this.testimonals.length;
    if (currentPage === 0) {
      this.carouselComponent.page = totalPages - 1;
      return;
    }
    if (currentPage !== 0) {
      this.carouselComponent.page = currentPage - 1;
      return;
    }
  }
}
